module.exports = __webpack_public_path__ + "static/media/logo-network.9ed297bd.svg";